import { apiGet, apiPost, apiSecurePost } from "../../api/client";
import type {
  CompareRequest,
  CompareResponse,
  OpportunityDetailsRequest,
  OpportunityDetailsResponse,
  SalesHistoryRequest,
  SalesHistoryResponse,
  SavedOpportunityListResponse,
  SavedOpportunityResponse,
  SkinQuotesResponse,
} from "./types";

export function getComparison(
  payload: CompareRequest,
  signal?: AbortSignal,
): Promise<CompareResponse> {
  return apiPost<CompareResponse, CompareRequest>(
    "/api/v1/compare",
    payload,
    signal,
  );
}

export function getOpportunityDetails(
  payload: OpportunityDetailsRequest,
  signal?: AbortSignal,
): Promise<OpportunityDetailsResponse> {
  return apiPost<OpportunityDetailsResponse, OpportunityDetailsRequest>(
    "/api/v1/opportunity-details",
    payload,
    signal,
  );
}

export function getSalesHistory(
  payload: SalesHistoryRequest,
  signal?: AbortSignal,
): Promise<SalesHistoryResponse> {
  return apiPost<SalesHistoryResponse, SalesHistoryRequest>(
    "/api/v1/sales-history",
    payload,
    signal,
  );
}

export function getSkinQuotes(
  skinId: number,
  signal?: AbortSignal,
): Promise<SkinQuotesResponse> {
  return apiGet<SkinQuotesResponse>(
    `/api/v1/skin-quotes?skin_id=${encodeURIComponent(skinId)}`,
    signal,
  );
}

export function getSavedOpportunities(
  signal?: AbortSignal,
): Promise<SavedOpportunityListResponse> {
  return apiGet<SavedOpportunityListResponse>(
    "/api/v1/account/saved-opportunities",
    signal,
  );
}

export function saveOpportunity(values: {
  opportunity_key: string;
  skin_id: number;
  buy_market: string;
  sell_market: string;
  is_deal: boolean;
  is_alert: boolean;
  snapshot: object;
}): Promise<SavedOpportunityResponse> {
  return apiSecurePost<SavedOpportunityResponse, typeof values>(
    "/api/v1/account/saved-opportunities",
    values,
  );
}
